module.exports = __webpack_public_path__ + "static/media/stock.cb097432.png";